
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[id]",
      function () {
        return require("private-next-pages/blogs/[id].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/[id]"])
      });
    }
  